module.exports = __webpack_public_path__ + "img/near-rift-depths.73daeaef.webp";